import { render, staticRenderFns } from "./CommercialPersonAliasEdit.vue?vue&type=template&id=b0208ea8&scoped=true&"
import script from "./CommercialPersonAliasEdit.vue?vue&type=script&lang=js&"
export * from "./CommercialPersonAliasEdit.vue?vue&type=script&lang=js&"
import style0 from "./CommercialPersonAliasEdit.vue?vue&type=style&index=0&id=b0208ea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0208ea8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VIcon,VSwitch,VTab,VTabs,VTextField})
